export default __webpack_public_path__ + "static/media/qblbasP18.678a2c0b.png";